// extracted by mini-css-extract-plugin
export default {"container":"MBIStandorte_container__dHC7r","places":"MBIStandorte_places__4ISMn","map":"MBIStandorte_map__ak1oI"};